export enum WhiteLabelingUploadType {
  LOGO = 'logo',
  AVATAR = 'avatar',
  PO_LOGO = 'poLogo',
}

export type UploadType = WhiteLabelingUploadType;
